import { e2eMode } from './e2e/e2eMode';
import { environment } from './environment';
import { NgModule } from '@angular/core';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers, indexLoginReducers, getInnermostChild, ConfigService } from '@uxdf/direct-shared-lib';
import { reducers as homepageReducers } from '../app/redux/reducers';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { Effects } from '../app/redux/effects/effects';
import { EffectsNews } from '../app/redux/effects/effects-news';
import { EffectsBonusPoints } from '../app/redux/effects/loyalty/effects-bonus-points';
import { EffectsAgent } from '../app/redux/effects/loyalty/effects-agent';
import { EffectsAccount } from '../app/redux/effects/loyalty/effects-account';
import { EffectsCustomer } from '../app/redux/effects/loyalty/effects-customer';
import { EffectsParticipation } from '../app/redux/effects/loyalty/effects-participation';
import { EffectsProfile } from '../app/redux/effects/account/effects-profile';
import { EffectsAgency } from '../app/redux/effects/account/effects-agency';
import { EffectsOrders } from '../app/redux/effects/account/effects-orders';
import { EffectsContracts } from '../app/redux/effects/account/effects-contracts';
import { EffectsInventory } from '../app/redux/effects/account/effects-inventory';
import { EffectsInvoices } from '../app/redux/effects/invoices/effects-invoices';
import { EffectsSegments } from '../app/redux/effects/invoices/effects-segments';
import { EffectsDashboard } from '../app/redux/effects/dashboard/effects-dashboard';
import { EffectsRouter } from '../app/redux/effects/effects-router';
import { EffectsLoyaltyTile } from '../app/redux/effects/effects-loyalty-tile';
import { EffectsBannerTile } from '../app/redux/effects/effects-banner-tile';
import { EffectsStatusPoints } from '../app/redux/effects/loyalty/effects-status-points';
import { EffectsAvcInvoices } from 'src/app/components/account/avc-invoices/redux/effects/effects-avc-invoices';

// used to enable logging service
const envMetaReducers = environment.production || e2eMode.e2e ? [] : metaReducers;
// can't be enabled until token permission actions changed to simple objects
const envRuntimeChecksEnabled = false; // !(environment.production || e2eMode.e2e);
const envRuntimeChecks = {
  strictStateImmutability: envRuntimeChecksEnabled,
  strictActionImmutability: envRuntimeChecksEnabled,
  strictStateSerializability: envRuntimeChecksEnabled,
  strictActionSerializability: envRuntimeChecksEnabled
};

@NgModule({
  providers: [
    { provide: Window, useValue: window },
    { provide: 'ASH_URL', useValue: environment.ASH_URL }
  ],
  imports: [
    StoreModule.forRoot(reducers, {
      metaReducers: envMetaReducers,
      runtimeChecks: envRuntimeChecks
    }),
    StoreModule.forFeature('homepage', homepageReducers),
    StoreModule.forFeature('login', indexLoginReducers),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([
      Effects,
      EffectsNews,
      EffectsBonusPoints,
      EffectsStatusPoints,
      EffectsAgent,
      EffectsAccount,
      EffectsCustomer,
      EffectsParticipation,
      EffectsProfile,
      EffectsAgency,
      EffectsOrders,
      EffectsContracts,
      EffectsInventory,
      EffectsInvoices,
      EffectsAvcInvoices,
      EffectsSegments,
      EffectsDashboard,
      EffectsRouter,
      EffectsLoyaltyTile,
      EffectsBannerTile
    ]),
    environment.devTools ? StoreDevtoolsModule.instrument({ maxAge: 10 }) : []
  ],
  exports: [StoreModule]
})
export class EnvModule { }
